export default __webpack_public_path__ + "static/media/lenco-transfer.e8daf02b.svg";